import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography, ListItem, List, ListItemText, ListItemAvatar,
} from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import SeedAuthenticationRepository from '../../../components/repository/SeedAuthenticationRepository';
import seedDrawerRoutes from '../../../components/route/seed-drawer-routes';
import { drawerRoutesPropTypes, dashboard3DrawersIconsPropTypes } from '../../../components/page/dashboard-3-drawers/d3d-prop-types';
import seedLogo from '../../../components/images/logo.svg';
import { seedDashboard3DrawersIcons } from '../../../components/icon/seed-icons';
import UserRepository from '../../repository/UserRepository';
import { AppState } from '../../../components/state/MyStateProvider';
import { FirebaseState } from '../../../components/firebase/MyFirebaseProvider';
import MyAvatar from '../../../components/widgets/avatar/MyAvatar';
import DashboardDrawerBottomNav from '../../../components/page/dashboard-drawer-bottomnav/DashboardDrawerBottomNav';

const FriendsPage = (props) => {
  const {
    AuthenticationRepository,
    drawerRoutes,
    applicationName,
    logo,
    icons,
    pageUtils,
    popoverMenus,
    bottomNavMenus,
  } = props;
  const intl = useIntl();
  const { state } = React.useContext(AppState);
  const { firebaseConfig } = React.useContext(FirebaseState);

  const [userRepository] = React.useState(new UserRepository(firebaseConfig, state));
  const [data, setData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    setIsLoading(true);
    pageUtils.loadSomethingSilent(
      () => userRepository.getAll(),
      (payload) => {
        setData(payload);
      },
      (error) => {
        pageUtils.showSnackbar(error.message, 'error');
      },
      () => {
        setIsLoading(false);
      },
    );

    return () => {

    };
  }, [userRepository, pageUtils]);

  return (
    <DashboardDrawerBottomNav
      titleId="rafflesia.friends.title"
      routes={drawerRoutes}
      AuthenticationRepository={AuthenticationRepository}
      applicationName={applicationName}
      logo={logo}
      isLoading={isLoading}
      icons={icons}
      popoverMenus={popoverMenus}
      bottomNavMenus={bottomNavMenus}
    >
      {
        isLoading ? (
          <Typography color="textPrimary">
            <FormattedMessage
              id="rafflesia.friends.text.loading"
            />
          </Typography>
        ) : (
          <List>
            {
              data.map((friend) => (
                <ListItem
                  component="a"
                  key={`friend-item-${friend.id}`}
                  button
                  href={`/user/${friend.username}`}
                >
                  <ListItemAvatar>
                    <MyAvatar
                      src={friend.photoURL}
                      name={friend.username}
                      alt={friend.username}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={friend.username}
                    secondary={
                      intl.formatMessage({
                        id: 'rafflesia.friends.user.joined',
                      }, {
                        time: intl.formatDate(
                          new Date(friend.creationTime),
                          {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                          },
                        ),
                      })
                    }
                  />
                </ListItem>
              ))
            }
          </List>
        )
      }
    </DashboardDrawerBottomNav>
  );
};

FriendsPage.propTypes = {
  AuthenticationRepository: PropTypes.func,
  applicationName: PropTypes.string,
  logo: PropTypes.string,
  drawerRoutes: drawerRoutesPropTypes,
  icons: dashboard3DrawersIconsPropTypes,
};

FriendsPage.defaultProps = {
  AuthenticationRepository: SeedAuthenticationRepository,
  applicationName: 'react-seed',
  logo: seedLogo,
  drawerRoutes: seedDrawerRoutes,
  icons: seedDashboard3DrawersIcons,
};

export default FriendsPage;
